(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.lodashFpConvert = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Lodash FP conversion options.
   * @constant {Object}
   * @memberof util
   * @since 0.1.5
   * @private
   */
  var lodashFpConvertOptions = {
    rearg: false,
    curry: false
  };

  /**
   * Converts a lodash/fp function with {@link util.lodashFpConvertOptions|lodashFpConvertOptions}.
   * @function lodashFpConvert
   * @memberof util
   * @param {function} fn The lodash/fp function.
   * @return {function} Returns the converted lodash/fp function.
   * @since 0.2.0
   * @private
   */
  var lodashFpConvert = function lodashFpConvert(fn) {
    return fn.convert(lodashFpConvertOptions);
  };
  exports.lodashFpConvert = lodashFpConvert;
  exports.default = lodashFpConvert;
});